import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import PortfolioPage from '@/pages/portfolio/page';
import FranchiseRevenuePage from '@/pages/franchise/revenue/page';
import FranchiseGuidePage from '@/pages/franchise/guide/page';
import FranchiseInteriorPage from '@/pages/franchise/interior/page';
import FranchiseSupportPage from '@/pages/franchise/support/page';
import FranchiseCasesPage from '@/pages/franchise/cases/page';
import FranchiseStoresPage from '@/pages/franchise/stores/page';
import InquiryPage from '@/pages/community/inquiry/page';
import NoticePage from '@/pages/community/notice/page';
import EventsPage from '@/pages/community/events/page';
import BrandAboutPage from '@/pages/brand/about/page';
import BrandSafetyPage from '@/pages/brand/safety/page';
import BrandArtistsPage from '@/pages/brand/artists/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },

  // Brand
  { path: '/brand', element: <BrandAboutPage /> },
  { path: '/brand/about', element: <BrandAboutPage /> },
  { path: '/brand/safety', element: <BrandSafetyPage /> },
  { path: '/brand/artists', element: <BrandArtistsPage /> },
  { path: '/brand/artists/senior', element: <BrandArtistsPage /> },
  { path: '/brand/artists/junior', element: <BrandArtistsPage /> },

  // Gallery / Portfolio
  { path: '/portfolio', element: <PortfolioPage /> },
  { path: '/portfolio/genre', element: <PortfolioPage /> },
  { path: '/portfolio/genre/black-gray', element: <PortfolioPage /> },
  { path: '/portfolio/genre/minimal', element: <PortfolioPage /> },
  { path: '/portfolio/genre/irezumi', element: <PortfolioPage /> },
  { path: '/portfolio/body-part', element: <PortfolioPage /> },

  // Franchise
  { path: '/franchise', element: <FranchiseGuidePage /> },
  { path: '/franchise/guide', element: <FranchiseGuidePage /> },
  { path: '/franchise/guide/process', element: <FranchiseGuidePage /> },
  { path: '/franchise/guide/cost', element: <FranchiseGuidePage /> },
  { path: '/franchise/interior', element: <FranchiseInteriorPage /> },
  { path: '/franchise/support', element: <FranchiseSupportPage /> },
  { path: '/franchise/support/marketing', element: <FranchiseSupportPage /> },
  { path: '/franchise/support/logistics', element: <FranchiseSupportPage /> },
  { path: '/franchise/cases', element: <FranchiseCasesPage /> },
  { path: '/franchise/revenue', element: <FranchiseRevenuePage /> },
  { path: '/franchise/stores', element: <FranchiseStoresPage /> },

  // Community
  { path: '/community', element: <NoticePage /> },
  { path: '/community/notice', element: <NoticePage /> },
  { path: '/community/events', element: <EventsPage /> },
  { path: '/community/inquiry', element: <InquiryPage /> },

  { path: '*', element: <NotFound /> },
];

export default routes;
